<template>
  <div class="address-form">
    <form @submit.prevent="handleSave">
      <div class="form-group">
        <label>Name</label>
        <input v-model="formData.name" type="text" />
      </div>
      <div class="form-group">
        <label>Company</label>
        <input v-model="formData.company" type="text" />
      </div>
      <div class="form-group">
        <label>Street 1</label>
        <input v-model="formData.street1" type="text" />
      </div>
      <div class="form-group">
        <label>Street 2</label>
        <input v-model="formData.street2" type="text" />
      </div>
      <div class="form-group">
        <label>Street 3</label>
        <input v-model="formData.street3" type="text" />
      </div>
      <div class="form-group">
        <label>City</label>
        <input v-model="formData.city" type="text" />
      </div>
      <div class="form-group">
        <label>State</label>
        <input v-model="formData.state" type="text" />
      </div>
      <div class="form-group">
        <label>Postal Code</label>
        <input v-model="formData.postalCode" type="text" />
      </div>
      <div class="form-group">
        <label>Country</label>
        <input v-model="formData.country" type="text" />
      </div>
      <div class="form-group">
        <label>Phone</label>
        <input v-model="formData.phone" type="text" />
      </div>
      <div class="form-group">
        <label>
          <input v-model="formData.residential" type="checkbox" />
          Residential
        </label>
      </div>
      <div class="form-group">
        <label>
          <input v-model="formData.address_verified" type="checkbox" />
          Address Verified
        </label>
      </div>
      <div class="form-actions">
        <button type="submit" class="save-button" :disabled="isSaving">
          {{ isSaving ? "Saving..." : "Save" }}
        </button>
        <button
          type="button"
          @click="handleCancel"
          class="cancel-button"
          :disabled="isSaving"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    address: {
      type: Object,
      required: true
    },
    isSaving: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.address))
    };
  },
  watch: {
    address: {
      handler(newVal) {
        // Only reset if the address changes significantly (e.g., when switching between addresses)
        if (newVal && Object.keys(newVal).length > 0) {
          this.formData = JSON.parse(JSON.stringify(newVal));
        }
      },
      deep: true
    }
  },
  methods: {
    handleSave() {
      // Emit save with the current form data
      this.$emit("save", { ...this.formData });
    },
    handleCancel() {
      this.$emit("cancel");
    }
  }
};
</script>

<style scoped>
.address-form {
  padding: 10px;
}

.form-group {
  margin-bottom: 12px;
}

.form-group label {
  display: block;
  margin-bottom: 4px;
  font-weight: 500;
  font-size: 14px;
}

.form-group input[type="text"],
.form-group input[type="email"] {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

.form-group input[type="text"]:focus,
.form-group input[type="email"]:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 5px rgba(74, 144, 226, 0.3);
}

.form-group input[type="checkbox"] {
  margin-right: 8px;
}

.form-actions {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.save-button,
.cancel-button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  font-weight: 500;
}

.save-button {
  background-color: #28a745;
  color: white;
}

.save-button:hover:not(:disabled) {
  background-color: #218838;
}

.save-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.cancel-button {
  background-color: #6c757d;
  color: white;
}

.cancel-button:hover:not(:disabled) {
  background-color: #5a6268;
}

.cancel-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>
